import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { UserAnalyzerPermission } from 'types';

export const createAnalyzerPermission = async ({
  userId,
  analyzerId,
}: {
  userId: number;
  analyzerId: number;
}): Promise<UserAnalyzerPermission> => {
  const response = await axios.post(
    `/api/users/${userId}/analyzer/${analyzerId}/permissions`
  );
  return response.data as UserAnalyzerPermission;
};

type UseCreateAnalyzerPermissionOptions = {
  config?: MutationConfig<typeof createAnalyzerPermission>;
};

export const useCreateAnalyzerPermission = ({
  config,
}: UseCreateAnalyzerPermissionOptions = {}) => {
  return useMutation({
    onSuccess: (createdPermissions) => {
      queryClient.invalidateQueries(['user', createdPermissions.user_id]);
    },
    ...config,
    mutationFn: createAnalyzerPermission,
  });
};
